import React from "react";
import { FDialog } from "ferrum-design-system";
import { AiOutlineCheck } from "react-icons/ai";
import { networkImages } from "../../../../utils/networkImages";
import IconMetaMask from "../../../../assets/img/icon-metamask.svg";
import algorandIcon from "../../../../assets/ms-new-images/Algorand-logo.svg";

export const MsDestinationDialog = ({ show, onHide }: any) => {
  return (
    <FDialog
      show={show}
      size={"large"}
      onHide={onHide}
      variant={"destination-address"}
      title="Destination Address"
    >
      <>
        <div>
          <p className="ms-select-destination-description">
            Lorem ipsum dolor sit amet, consectetuer adipiscinge elitenean
            commodo ligula eget dolor cum sociis natoque dolor sit amet
            consectetuer.
          </p>
          <div className="ms-select-destination-address-first">
            <div className="d-flex">
              <img width="25px" src={networkImages["BSC"]} alt="BSC" />
              <img width="25px" src={IconMetaMask} alt="IconMetaMask" />
            </div>
            <input placeholder="0x071ef1A1f8B9332d9E48b35705481c92E64b4444" />
            <button className="ms-select-destination-address-first-button">
              <AiOutlineCheck color="white" />
              Connected
            </button>
          </div>
          <div className="ms-select-destination-address-second">
            <img width="25px" src={algorandIcon} alt="algorandIcon" />
            <input placeholder="Add Destination Address" />
            <button className="ms-select-destination-address-second-button">
              Confirm
            </button>
          </div>
        </div>
      </>
    </FDialog>
  );
};
